import { render, staticRenderFns } from "./UpdateSundryItemStockPopUp.vue?vue&type=template&id=71ca1f38&scoped=true&"
import script from "./UpdateSundryItemStockPopUp.vue?vue&type=script&lang=js&"
export * from "./UpdateSundryItemStockPopUp.vue?vue&type=script&lang=js&"
import style0 from "./UpdateSundryItemStockPopUp.vue?vue&type=style&index=0&id=71ca1f38&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ca1f38",
  null
  
)

export default component.exports